import axios from "axios";
import { EMPLOYEE, PHOTO } from "../endpointsConst";

const CompanyService = {};

CompanyService.addEmployee = (data) => axios.post(EMPLOYEE, data);

CompanyService.editEmployee = (data) => axios.put(EMPLOYEE, data);

CompanyService.deleteEmployee = (id) => axios.delete(EMPLOYEE + `/${id}`);

CompanyService.editEmployeePhoto = (data) => axios.put(EMPLOYEE + PHOTO, data);

export { CompanyService };
